import { P, H1, H2, Ul, Image } from "design_lib";

export default function DefineMissionPathway() {
  return (
    <div>
      <P>
        One of the most important characteristic that investors look for in a company is a
        leadership team that works together and has direction. This is largely due to how united the
        team is. The mission statement defines what is uniting the leadership team and the company
        together. Without it, each employee of the company can have their own view of what the
        company is and where it should end up, resulting in confusion and divergence as the company
        grows.
      </P>
      <P>
        The mission statement should also describe why the company is in business, and what the
        company aspires to attain. It must transcend the desire for monetary gains and, instead,
        reflect how company financial success will make the community, the country, or the world, a
        better place beyond the products that it sells. The further the mission gets from the needs
        of the business, the more effective it will be to inspire individuals inside and outside the
        company. However, it must be actionable within the company itself.
      </P>

      <P>A mission statement should have the following:</P>
      <Ul>
        <li>Transcend product and market life cycles</li>
        <li>Be motivating and inspiring</li>
        <li>Reflect a choice</li>
        <li>Be short, clear, and easy to remember</li>
        <li>It should be unique in reflecting the company that it belongs to</li>
        <li>It must be coherent with the Vision and Values of the company"</li>
      </Ul>
      <H1>Examples</H1>

      <H2>Forbes</H2>

      <P>
        "To deliver information on the people, ideas and technologies changing the world to our
        community of affluent business decision makers"
      </P>
      <P>
        This mission statement is strategic, dictating where and how they will act but doesn't
        instill inspiration or motivation.
      </P>

      <H2>American Red Cross</H2>

      <P>
        "To prevent and alleviate human suffering in the face of emergencies by mobilizing the power
        of volunteers and the generosity of donors"
      </P>

      <P>
        This example is very motivating as it talks to things that matter to everyone: human
        suffering and emergencies. It also has strategy, citing that it mobilizes volunteers and
        donors help to achieve this mission."
      </P>

      <H2>Nike</H2>

      <P>
        "Bring inspiration and innovation to every athlete in the world. If you have a body, you are
        an athlete."
      </P>
      <P>
        Nike has an interesting take on mission statements. In defining what an 'athlete' is to
        itself, it also defines it for all who read this statement. It is clearly motivational as it
        hits the human desire to be fit, and defines its simple strategy how it will do so.
      </P>
      <H2>Albertsons</H2>

      <P>
        "To create a shopping experience that pleases our customers; a workplace that creates
        opportunities and a great working environment for our associates; and a business that
        achieves financial success"
      </P>

      <P>
        Unfortunately, this isn't inspirational or strategic. It states what they'd like to achieve
        but doesn't have any indication how the company will achieve these goals. In addition, the
        goals are as inspiring as new year's resolutions no one seems to reach."
      </P>
      <H2>Fred Meyer</H2>

      <P>
        "While our stores change with the times, one thing stays the same - our commitment to
        Customers"
      </P>

      <P>
        This is unique, in that it has almost no strategy how it will achieve its mission but the
        statement is so strong it makes the reader clench their fist with determination, like its a
        call to battle or to weather a storm."
      </P>

      <H2>Starbucks</H2>

      <P>
        "With every cup, with every conversation, with every community - we nurture the limitless
        possibilities of human connection"
      </P>

      <P>
        Inspriational and strategic, Starbucks indicates why its in business and how it will do it.
        Limited possibilities brings emotions while cups clearly define its a beverage company that
        facilitates meeting together."
      </P>
      <H2>USPS</H2>

      <P> "To provide the nation with reliable, affordable, universal mail service. "</P>
      <P>
        Not strategic (how it will do it) or inspirational. Interestingly enough, the law that
        created the USPS states the following about the purpose of the USPS:
      </P>

      <P>
        "...to bind the Nation together through the personal, educational, literary, and business
        correspondence of the people."
      </P>

      <P>This is inspriational and it clearly defines strategy how it will do it.</P>

      <P>
        The framework below helps evaluate the mission, vision, and value statements, indivudally
        and collectively, to decide if they are motivational, have strategy, and if those are
        coherent with each other.
      </P>
      <P>
        Patagonia's mission, "We're in business to save our home planet," is very inspirational but
        has no strategy to it at all. They instead stretch their Values to include how they will
        make this happen. In this way, the culmination of their mission, vision, and values show
        motivation, strategy, and cohesion.
      </P>
      <Image src={require("lib/img/pathways/DefineMission.png")} alt="" />
    </div>
  );
}
